var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",attrs:{"width":_vm.getSize(_vm.width),"height":_vm.getSize(_vm.height),"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }